import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppDownload from '../components/AppDownload';
import logo from '../res/betterhusband_black.png';

const DownloadApp = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('it') ? 'it' : 'en';

  return (
    <div className="min-h-screen bg-[#F8F7F4] flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-[360px] text-center">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <img src={logo} alt="Better Husband" className="w-10 h-10 object-contain" />
          <span
            className="font-serif text-xl font-medium text-stone-900"
            style={{ fontFamily: 'Manrope-Variable, Manrope, sans-serif' }}
          >
            Better Husband
          </span>
        </div>

        {/* Checkmark icon */}
        <div className="flex justify-center mb-8">
          <div className="w-[80px] h-[80px] rounded-full bg-emerald-50 flex items-center justify-center shadow-[0_0_0_12px_rgba(16,185,129,0.06)]">
            <div className="w-[60px] h-[60px] rounded-full bg-emerald-600 flex items-center justify-center shadow-[0_12px_28px_rgba(5,150,105,0.24)]">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth={3}
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
        </div>

        {/* Title & subtitle */}
        <h1
          className="text-[22px] leading-7 font-semibold mb-3 text-stone-950"
          style={{ fontFamily: 'Manrope-Variable, Manrope, sans-serif' }}
        >
          {t('downloadApp.title')}
        </h1>
        <p
          className="text-[15px] leading-6 text-stone-500 mx-auto max-w-[280px] mb-10"
          style={{ fontFamily: 'Manrope-Variable, Manrope, sans-serif' }}
        >
          {t('downloadApp.subtitle')}
        </p>

        {/* App store badges */}
        <AppDownload lang={lang} />

        {/* Back link */}
        <div className="mt-10">
          <Link
            to="/landing/home"
            className="text-[13px] text-stone-400 hover:text-stone-600 underline underline-offset-2 transition-colors"
            style={{ fontFamily: 'Manrope-Variable, Manrope, sans-serif' }}
          >
            {t('downloadApp.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
